<template>
    <v-row justify="center">
        <v-dialog
            v-model="show"
            persistent
            max-width="450">
            <v-card>
                <div
                    class="close pt-3 px-7"
                    @click="close()">
                    x
                </div>
                <v-card-title class="headline flex-center">
                    {{ title }}
                </v-card-title>

                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.name"
                                        :rules="inputRules"
                                        :error-messages="errors.name"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.specialWorkdayName')"
                                        :placeholder="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.enterSpecialWorkdayName')">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="form.bureau"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.bureau')"
                                        :placeholder="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.selectBureau')"
                                        :items="bureauItems"
                                        :rules="bureauItemsRules"
                                        @change="(event) => checkStates(event)"
                                        multiple>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                    <v-menu
                                        v-model="workDatePickerShow"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="234px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="workDateFormatted"
                                                append-icon="event"
                                                @click:append="workDatePickerShow = true"
                                                @click:clear="form.date = null"
                                                :rules="inputRules"
                                                :error-messages="errors.date"
                                                readonly
                                                :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.workDate')"
                                                placeholder="DD/MM/YYYY"
                                                v-on="on"
                                                height="40px"
                                                background-color="#ffffff">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                            locale="th-TH"
                                            v-model="form.date"
                                            @change="formatWorkDate"
                                            :min="minDate"
                                            @input="workDatePickerShow = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="6">
                                    <hours-input
                                        v-model="form.checkin_time"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.checkInTime')"
                                        default-value=""
                                        :error-messages="errors.checkin_time"/>
                                </v-col>
                                <v-col cols="6">
                                    <hours-input
                                        v-model="form.start_time"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.startTime')"
                                        default-value=""
                                        :error-messages="errors.start_time"/>
                                </v-col>
                                <v-col cols="6">
                                    <hours-input
                                        v-model="form.late_checkin_time"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.lateCheckIn')"
                                        default-value=""
                                        :error-messages="errors.late_checkin_time"/>
                                </v-col>
                                <v-col cols="6">
                                    <hours-input
                                        v-model="form.last_checkin_time"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.lastCheckIn')"
                                        default-value=""
                                        :error-messages="errors.last_checkin_time"/>
                                </v-col>
                                <v-col cols="6">
                                    <v-select
                                        v-model="form.breakhours"
                                        :items="breakHoursItems"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.breakHours')">
                                    </v-select>
                                </v-col>
                                <v-col cols="6">
                                    <hours-input
                                        v-model="form.end_time"
                                        :label="$vuetify.lang.t('$vuetify.specialWorkdayFormModal.endTime')"
                                        default-value=""
                                        :error-messages="errors.end_time"/>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions class="flex-center">
                    <v-btn
                        class="save-btn"
                        color="primary"
                        width="264"
                        @click="save()">
                        {{ $vuetify.lang.t('$vuetify.specialWorkdayFormModal.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import HoursInput from '@/components/HoursInput.vue'

export default {
    name: 'SpecialWorkdayFormModal',

    components: {
        HoursInput
    },

    props: {
        mode: {
            type: String,
            default: ''
        },
        specialWorkdayId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            title: this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.header'),
            valid: true,
            workDatePickerShow: false,
            workDateFormatted: null,
            show: true,
            form: this.getDefaultForm(),
            errors: this.getDefaultErrors(),
            minDate: this.getDateTomorrow().toISOString().substr(0, 10),
            breakHoursItems: [
                '1:00',
                '1:15',
                '1:30',
                '1:45',
                '2:00',
                '2:15',
                '2:30'
            ],
            bureauItems: [],
            selectedItems: []
        }
    },

    computed: {
        inputRules () {
            return [
                v => !!v || this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.require')
            ]
        },

        bureauItemsRules () {
            return [
                v => !(v.length < 1) || this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.requireBureau')
            ]
        }
    },

    methods: {
        getDateTomorrow () {
            const date = new Date()
            date.setDate(date.getDate() + 1)
            return date
        },

        formatWorkDate () {
            this.workDateFormatted = this.$dateUtil.formatDate(this.form.date)
        },

        getDefaultForm () {
            return {
                name: '',
                bureau: [],
                date: this.getDateTomorrow().toISOString().substr(0, 10),
                checkin_time: '',
                start_time: '',
                late_checkin_time: '',
                last_checkin_time: '',
                breakhours: '1:00',
                end_time: ''
            }
        },

        getDefaultErrors () {
            return {
                name: null,
                checkin_time: null,
                start_time: null,
                late_checkin_time: null,
                last_checkin_time: null,
                end_time: null,
                date: null
            }
        },

        close () {
            this.$emit('close')
        },

        validateTimeByKey (key) {
            let isValid = true
            if (!this.form[key]) {
                this.errors[key] = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.require')
                isValid = false
            } else {
                this.errors[key] = null
            }

            return isValid
        },

        validateTimeFields () {
            const validatedKeys = ['checkin_time', 'start_time', 'late_checkin_time', 'last_checkin_time', 'end_time']

            for (let i = 0; i < validatedKeys.length; i++) {
                if (!this.validateTimeByKey(validatedKeys[i])) {
                    return false
                }
            }

            this.validateCheckInTime()
            this.validateStartTime()
            this.validateLateCheckIn()
            this.validateLastCheckIn()
            this.validateEndTime()

            for (let i = 0; i < validatedKeys.length; i++) {
                // if there is/are value in this.errors that means failed validation
                if (this.errors[validatedKeys[i]]) {
                    return false
                }
            }

            return true
        },

        validateCheckInTime () {
            if (this.form.checkin_time && this.form.start_time && this.form.checkin_time >= this.form.start_time) {
                this.errors.checkin_time = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.checkInTimeLessThanStartTime')
            } else {
                this.errors.checkin_time = null
            }
        },

        validateStartTime () {
            if (this.form.start_time && this.form.late_checkin_time && this.form.start_time >= this.form.late_checkin_time) {
                this.errors.start_time = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.startTimeLessThanLateCheckIn')
            } else {
                this.errors.start_time = null
            }
        },

        validateLateCheckIn () {
            if (this.form.late_checkin_time && this.form.last_checkin_time && this.form.late_checkin_time >= this.form.last_checkin_time) {
                this.errors.late_checkin_time = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.lateCheckInLessThanLastCheckIn')
            } else {
                this.errors.late_checkin_time = null
            }
        },

        validateLastCheckIn () {
            if (this.form.last_checkin_time && this.form.end_time && this.form.last_checkin_time >= this.form.end_time) {
                this.errors.last_checkin_time = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.lastCheckInLessThanEndTime')
            } else {
                this.errors.last_checkin_time = null
            }
        },

        validateEndTime () {
            if (this.form.end_time && this.form.last_checkin_time && this.form.last_checkin_time >= this.form.end_time) {
                this.errors.end_time = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.endTimeMoreThanLastCheckIn')
            } else {
                this.errors.end_time = null
            }
        },

        async save () {
            const isValid = this.$refs.form.validate()
            if (!this.validateTimeFields()) {
                return
            }
            if (!isValid) {
                return
            }

            if (this.mode === 'create') {
                await this.createSpecialWorkday()
            } else {
                await this.updateSpecialWorkday()
            }
        },

        async createSpecialWorkday () {
            this.$store.dispatch('setLoading', true)

            const res = await this.axios.post('special-workday/create', this.form)
            this.handleResponse(res)
        },

        async updateSpecialWorkday () {
            const res = await this.axios.put(`special-workday/edit/${this.specialWorkdayId}`, this.form)
            this.handleResponse(res)
        },

        handleResponse (response) {
            if (response && response.data && response.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)

                const createdText = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.created')
                const updatedText = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.updated')

                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.congratulation'),
                    text: this.mode === 'create' ? createdText : updatedText,
                    type: 'notify-success'
                })
                this.$emit('success')
                this.close()
            } else if (response && response.data && response.data.status === 'error_inputs') {
                this.errors = response.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.errorTitle'),
                        text: this.errors[property],
                        type: 'notify-error'
                    })
                }
            }
        },

        async getSpecialWorkday () {
            const res = await this.axios.get(`special-workday/${this.specialWorkdayId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.form = { ...res.data.data }
            }
        },

        async getBureaus () {
            const res = await this.axios.get('bureau/options')
            if (res && res.data && res.data.status === 'ok') {
                this.bureauItems = res.data.data
            }
        },

        checkStates (newValues) {
            const newValCheckedAll = newValues.filter(obj => { return obj === null })
            const oldValCheckAll = this.selectedItems.filter(obj => { return obj === null })
            if (newValCheckedAll.length > oldValCheckAll.length) {
                // select all
                this.selectedItems = newValues
                const values = []
                this.bureauItems.forEach(obj => {
                    values.push(obj.value)
                })
                this.form.bureau = values
            } else if (oldValCheckAll.length > newValCheckedAll.length) {
                // remove all
                this.selectedItems = newValues
                this.form.bureau = []
            }
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        await this.getBureaus()
        if (this.mode === 'update') {
            this.title = this.$vuetify.lang.t('$vuetify.specialWorkdayFormModal.headerEdit')
            await this.getSpecialWorkday()
        }
        this.formatWorkDate()
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        'form.checkin_time': {
            handler: async function () {
                this.validateTimeByKey('checkin_time')
                this.validateCheckInTime()
            },
            deep: true
        },
        'form.start_time': {
            handler: async function () {
                this.validateTimeByKey('start_time')
                this.validateCheckInTime()
                this.validateStartTime()
            },
            deep: true
        },
        'form.late_checkin_time': {
            handler: async function () {
                this.validateTimeByKey('late_checkin_time')
                this.validateStartTime()
                this.validateLateCheckIn()
            },
            deep: true
        },
        'form.last_checkin_time': {
            handler: async function () {
                this.validateTimeByKey('last_checkin_time')
                this.validateLateCheckIn()
                this.validateLastCheckIn()
            },
            deep: true
        },
        'form.end_time': {
            handler: async function () {
                this.validateTimeByKey('end_time')
                this.validateLastCheckIn()
                this.validateEndTime()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.flex-center {
    display: flex;
    justify-content: center;
}
.save-btn {
    margin-bottom: 16px;
}
.close {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    font-weight: 600;
}
</style>
